import React from "react";

export default function NewYearFrame3({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-3ne3,.cls-3ne4,.cls-3ne5,.cls-3ne7,.cls-3ne8{fill:none;stroke-miterlimit:10}.cls-3ne3,.cls-3ne4,.cls-3ne5,.cls-3ne8{stroke:#f2673f}.cls-3ne2{fill:#fce9d2}.cls-3ne3,.cls-3ne4,.cls-3ne5,.cls-3ne8{stroke-width:2.92px}.cls-3ne4{stroke-dasharray:6.93 6.93}.cls-3ne5{stroke-dasharray:7.02 7.02}.cls-3ne6{fill:#f2673f}.cls-3ne7{stroke:#020202;stroke-linecap:round;stroke-width:3.1px}.cls-3ne8{stroke-dasharray:6.97}"
            }
          </style>
        </defs>
        <g
          id="\u0421\u043B\u043E\u0439_6"
          data-name="\u0421\u043B\u043E\u0439 6"
        >
          <rect
            width={1192.78}
            height={1192.78}
            x={510.7}
            y={249.64}
            rx={223.86}
            style={{
              strokeWidth: "18.81px",
              strokeDasharray: 44.96,
              stroke: "#f2673f",
              fill: "none",
              strokeMiterlimit: 10,
            }}
          />
          <path
            d="m454.8 1208.76-231.24-22.21c-.85-22.06-2.11-55.32-3.53-95.81-4.91-139.14-6.38-208.38 20.6-280.89 7.32-19.67 16.73-39.57 36.17-56.21 33.5-28.69 75.81-29.74 94.61-29 20.2 3.54 59.13 13.58 87.37 46.43 14.1 16.41 25.79 38.8 31.5 75.44 18.04 115.82-29.59 335.58-35.48 362.25Z"
            className="cls-3ne2"
          />
          <path d="m442 1215-.71 3.41-3.47-.34" className="cls-3ne3" />
          <path d="m430.92 1217.39-189.72-18.22" className="cls-3ne4" />
          <path
            d="m237.75 1198.84-3.47-.33c0-1.13-.06-2.3-.09-3.49"
            className="cls-3ne3"
          />
          <path
            d="M234 1188c-.55-21.29-1.26-50.16-2-84.2-3.14-137.52-3.84-206 21-277.9 6.73-19.51 15.34-39.26 32.91-55.89 30.28-28.67 68.2-30.08 85-29.48 18.07 3.31 52.87 12.89 77.88 45.12 12.49 16.09 22.76 38.12 27.55 74.3 14.21 107.38-24.34 306-33.64 351.58"
            className="cls-3ne5"
          />
          <path
            d="m443.05 1216-79.84-79.86 121.21-151.58a58 58 0 0 1 81.46-9.06c6 5.88 16.06 17.47 17.29 33.28 1.35 17.41-8.64 31-15.12 39.57-38.88 51.39-70.3 82.7-94.66 116.79a365.79 365.79 0 0 0-30.34 50.86Z"
            className="cls-3ne2"
          />
          <rect
            width={292.14}
            height={85.38}
            x={187.7}
            y={1189.91}
            className="cls-3ne6"
            rx={30.27}
            transform="rotate(5.48 334.02 1233.67)"
          />
          <path
            d="M210.89 1186.13c-.71 3.33-4.08 68.94-4.08 68.94M250.55 1189.94c-.7 3.33-4.08 68.94-4.08 68.94M290.22 1193.75c-.71 3.33-4.08 68.94-4.08 68.94M329.88 1197.55c-.7 3.34-4.08 69-4.08 69M369.55 1201.36c-.71 3.34-4.08 69-4.08 69M409.21 1205.17c-.7 3.34-4.08 68.94-4.08 68.94M448.88 1209c-.71 3.34-4.08 68.94-4.08 68.94"
            className="cls-3ne7"
          />
          <path
            d="M416 1203c41.68-44 75.05-82.34 99.78-111.78 28.86-34.35 47.53-58.49 40.12-81-6.15-18.69-26.84-25.78-28.16-26.21-19.89-6.49-43.54 1.67-59.18 21.11"
            className="cls-3ne8"
          />
          <path
            d="M462.49 1010.62c-2.52 2.29-43.73 53.45-43.73 53.45"
            className="cls-3ne7"
          />
          <path
            d="M1098.45 1566.25 1257 1736.07c18-12.77 45.15-32 78.12-55.58 113.32-80.89 169.12-121.91 210.18-187.49 11.13-17.79 21.18-37.37 22.53-62.93 2.34-44-22.62-78.23-34.69-92.66-15.11-13.86-46.8-38.61-90-41-21.6-1.18-46.48 3.19-79 21-102.91 56.24-248.14 227.92-265.69 248.84Z"
            className="cls-3ne2"
          />
          <path d="m1101.32 1580.18-2.28 2.64 2.38 2.55" className="cls-3ne3" />
          <path d="m1106.15 1590.44 130.05 139.34" className="cls-3ne4" />
          <path d="m1238.56 1732.31 2.38 2.55 2.82-2" className="cls-3ne3" />
          <path
            d="M1249.43 1728.68c17.21-12.55 40.54-29.57 68-49.69 111-81.31 165.66-122.46 207.57-186 11.37-17.23 21.78-36.1 24.27-60.16 4.28-41.48-17.71-72.4-28.45-85.39-13.63-12.31-42.44-34.06-83.23-34.26-20.37-.1-44.1 5.18-75.7 23.43-93.8 54.15-227.8 205.74-258.28 240.89"
            className="cls-3ne5"
          />
          <path
            d="m1099.88 1580 112 14.65 46.31-188.45a58 58 0 0 0-42.45-70.11c-8.34-1.21-23.64-2.09-36.93 6.57-14.62 9.53-19.32 25.74-22.16 36.09-17.06 62.15-22.74 106.14-34.93 146.22a364.79 364.79 0 0 1-21.84 55.03Z"
            className="cls-3ne2"
          />
          <rect
            width={292.14}
            height={85.38}
            x={1007.22}
            y={1634.05}
            className="cls-3ne6"
            rx={30.27}
            transform="rotate(-133.02 1153.384 1676.717)"
          />
          <path
            d="M1265 1745.86c-2.22 2.59-52.18 45.24-52.18 45.24M1237.82 1716.73c-2.21 2.59-52.18 45.24-52.18 45.24M1210.63 1687.6c-2.21 2.59-52.18 45.24-52.18 45.24M1183.44 1658.47c-2.21 2.59-52.18 45.24-52.18 45.24M1156.25 1629.34c-2.21 2.59-52.18 45.24-52.18 45.24M1129.07 1600.21c-2.22 2.59-52.19 45.24-52.19 45.24M1101.88 1571.08c-2.22 2.59-52.18 45.24-52.18 45.24"
            className="cls-3ne7"
          />
          <path
            d="M1126.68 1593.45c9.51-59.87 19.56-109.67 27.83-147.22 9.66-43.81 17.42-73.33 39.78-81.17 18.56-6.5 36.79 5.58 37.94 6.37 17.27 11.81 25.2 35.53 19.32 59.78"
            className="cls-3ne8"
          />
          <path
            d="M1250.87 1439.42c-.28 3.39-15.74 67.24-15.74 67.24"
            className="cls-3ne7"
          />
          <path
            d="M315.82 1273.76c.26 20.9 6.56 301.4 146.56 353.42 25.49 9.47 96.35 26.57 130.35-9 18.56-19.39 27.38-55.78 12.85-70.71-13-13.35-42.3-7.15-60 2.14-46.37 24.33-68 98.63-57.86 150 23.33 118.26 235 216.77 411.45 171.43 138.54-35.6 213.31-149.09 235.72-186.44"
            style={{
              strokeWidth: "12.59px",
              strokeDasharray: 52.48,
              stroke: "#f2673f",
              fill: "none",
              strokeMiterlimit: 10,
            }}
          />
        </g>
        {children}
      </g>
    </svg>
  );
}
